"use client"

import { useState } from "react"
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner } from "reactstrap"
import { BadgeService } from "../../../Service/myBadgeOrderService" // Adjust path based on your project structure
import { toast } from "react-toastify" // Assuming react-toastify is set up
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa" // Using react-icons

interface BadgeRequestModalProps {
  isOpen: boolean
  toggle: () => void
  onSuccess: () => void
}

/**
 * Modal component for requesting a new badge.
 * For host staff, this process is simplified and auto-approved.
 */
export default function BadgeRequestModal({ isOpen, toggle, onSuccess }: BadgeRequestModalProps) {
  const [loading, setLoading] = useState(false)

  const handleRequestBadge = async () => {
    setLoading(true)
    try {
      const order = await BadgeService.requestBadge()
      toast.success(`Badge request submitted! Order Number: ${order.order_number}`)
      onSuccess() // Call onSuccess to close modal and refresh list
    } catch (error: any) {
      console.error("Failed to request badge:", error)
      // Extract specific error message from backend response if available
      const errorMessage = error.response?.data?.detail || "Failed to submit badge request. Please try again."
      toast.error(errorMessage)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="md">
      <ModalHeader toggle={toggle} className="bg-primary text-white">
        <FaCheckCircle className="me-2" /> Request New Badge
      </ModalHeader>
      <ModalBody className="p-4 text-center">
        <p className="lead mb-3">Are you sure you are going to request a new badge?</p>
        
      </ModalBody>
      <ModalFooter className="bg-light d-flex justify-content-center">
        <Button color="secondary" onClick={toggle} disabled={loading} className="me-2">
          <FaTimesCircle className="me-2" /> Cancel
        </Button>
        <Button color="primary" onClick={handleRequestBadge} disabled={loading}>
          {loading ? (
            <>
              <Spinner size="sm" className="me-2" /> Submitting...
            </>
          ) : (
            <>
              <FaCheckCircle className="me-2" /> Confirm Request
            </>
          )}
        </Button>
      </ModalFooter>
    </Modal>
  )
}
